let _token = '';
export const TokenMemo = {
    Set: (token: string) => _token = token,
    Get: () => 'DEBUG#copperbadger'
}